import { InputInteraction } from "./InputInteraction";

export type Windows = "Windows";
export type Mac = "Mac";
export type Linux = "Linux";
export type Android = "Android";
export type Desktop = "Desktop";

export type Platform = Windows | Mac | Linux | Android | Desktop;

export class Platforms
{
  static readonly Desktop:Desktop = "Desktop";
  static readonly Windows:Windows = "Windows";
  static readonly Mac:Mac = "Mac";
  static readonly Linux:Linux = "Linux";
  static readonly Android:Android = "Android";

  static isDesktop( platform:Platform )
  {
    return platform == Platforms.Desktop || platform == Platforms.Windows || platform == Platforms.Mac || platform == Platforms.Linux;  
  }
}

export class PlatformCommandInteraction
{
  platform:Platform;
  inputs:InputInteraction[] = [];

  static forDesktop()
  {
    let pci = new PlatformCommandInteraction();
    pci.platform = Platforms.Desktop;
    return pci;
  }
}
